import React from 'react';
import ContactSide from './../../components/contactSide/ContactSide';

const Contact = () => (
    <>
        <ContactSide />
    </>
);

export default Contact;